import { Component } from 'vue-property-decorator';
import EditorBase from '../EditorBase';
import { Button } from 'streamlabs-beaker';
import ComponentHelper from '@/helpers/editor';
import Position from './Position.vue';
import GeneralSettings from './GeneralSettings.vue';
import VisibilityDeleteComponentButton from './VisibilityDeleteComponentButton.vue';

@Component({
  components: {
    SButton: Button,
    Position,
    GeneralSettings,
    VisibilityDeleteComponentButton,
  },
})
export default class ImageSettings extends EditorBase {
  get imageUrl(): string {
    if (!this.selectedComponent || !this.selectedComponent.value) return '';

    return this.selectedComponent.value;
  }

  get filename(): string {
    if (!this.selectedComponent || !this.selectedComponent.value) return '';

    let name = this.selectedComponent.value.split('/').pop();

    if (name.length > 19) name = `${name.slice(0, 10)}...${name.slice(-4)}`;

    return name;
  }

  get placeholderImageSrc(): string {
    return ComponentHelper.defaultImageSettings.value;
  }

  onRemove() {
    const data = {
      id: this.selectedComponent.id,
      value: this.placeholderImageSrc,
    };

    this.onComponentUpdate(data);
  }

  onUploadNewImage() {
    this.openUploadManager(true);
  }
}
